/**
 * 此文件用于注册全局组件
 */

import Vue from "vue";

// 滚动
import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";

// 扩展组件
import EleFormDynamic from "vue-ele-form-dynamic";
import EleFormDataEditor from "vue-ele-form-data-editor";
import CodeMirror from "vue-ele-form-codemirror";
// language js
import "codemirror/mode/javascript/javascript.js";
// theme css
import "codemirror/theme/base16-dark.css";
import Dynamic from "vue-ele-form-dynamic";
import Gallery from "vue-ele-form-gallery";
import ImageUploader from "vue-ele-form-image-uploader";
import JsonEditor from "vue-ele-form-upload-file";
import MarkdownEditor from "vue-ele-form-markdown-editor";
import TableEditor from "vue-ele-form-table-editor";
import TreeSelect from "vue-ele-form-tree-select";
import UploadFile from "vue-ele-form-upload-file";
import VideoUploader from "vue-ele-form-video-uploader";

// 扩展配置
import EleFormQuillEditor from "vue-ele-form-quill-editor";
import EleFormBMap from "vue-ele-form-bmap";
// 拖拽
import vueDraggable from "vuedraggable/src/vuedraggable";

// 代码编辑器
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css";
import "prismjs/themes/prism-tomorrow.css";

Vue.use(PerfectScrollbar);
Vue.component("dynamic", EleFormDynamic);
Vue.component("PrismEditor", PrismEditor);
Vue.component("vue-draggable", vueDraggable);
Vue.component("data-editor", EleFormDataEditor);
Vue.component("quill-editor", EleFormQuillEditor);
Vue.component("bmap", EleFormBMap);
Vue.component("codemirror", CodeMirror);
Vue.component("dynamic", Dynamic);
Vue.component("gallery", Gallery);
Vue.component("image-uploader", ImageUploader);
Vue.component("json-editor", JsonEditor);
Vue.component("markdown-editor", MarkdownEditor);
Vue.component("table-editor", TableEditor);
Vue.component("tree-select", TreeSelect);
Vue.component("upload-file", UploadFile);
Vue.component("video-uploader", VideoUploader);
